import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, ClipImage, SectionHead } from "./Reveal";
import { SITE } from "@/lib/site";

const POINTS = [
  ["Un solo referente", "Parli sempre con la stessa persona: niente rimpalli tra muratore, idraulico, elettricista e fornitori."],
  ["Forniture dirette", "Scegli con noi serramenti, pavimenti, rivestimenti e rubinetteria: li forniamo e li posiamo noi."],
  ["Tempi e costi chiari", "Preventivo dettagliato voce per voce e cronoprogramma condiviso prima di aprire il cantiere."],
];

export const About = () => (
  <section id="chi-siamo" data-testid="about-section" className="relative bg-[#ece5d8] text-[#1c1915] py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-14 lg:gap-10">
      <div className="lg:col-span-7">
        <SectionHead light label="Chi siamo" title={<>Una casa nuova, <em className="italic text-[#7d5a12]">un solo</em> interlocutore.</>}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#3b352d] max-w-xl">
            Slusariuc Costruzioni è un'impresa edile con sede ad Albano Laziale che opera a Roma e in tutta la provincia.
            Ci occupiamo di ristrutturazioni chiavi in mano: prendiamo in carico l'immobile così com'è e lo restituiamo
            finito, pulito e pronto da abitare.
          </p>
        </SectionHead>
        <div className="mt-16 grid sm:grid-cols-3 gap-10 border-t border-[#1c1915]/15 pt-10">
          {POINTS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.12}>
              <span className="font-display italic text-3xl text-[#7d5a12]">0{i + 1}</span>
              <h3 className="mt-3 font-display text-2xl">{t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#4a443a]">{d}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1} className="mt-14 bg-[#0d0d0e] text-[#f4f1ea] p-8 md:p-10">
          <p className="label">Certificazioni e documentazione</p>
          <p className="mt-3 text-sm md:text-base text-[#d8d2c6] leading-relaxed max-w-2xl">
            Lavoriamo in regola e senza sorprese: deteniamo le certificazioni ISO e tutta la documentazione necessaria
            a un'impresa edile per operare a Roma e in Italia.
          </p>
          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {["Certificazioni ISO", "Qualificazioni e autorizzazioni edilizie", "DURC e adempimenti regolari", "Polizza di responsabilità civile"].map((t) => (
              <li key={t} data-testid="about-compliance-item" className="flex items-center gap-3 text-sm text-[#f4f1ea]">
                <span className="w-5 h-5 shrink-0 rounded-full bg-[#d4a73c] text-[#0d0d0e] flex items-center justify-center"><Check size={12} strokeWidth={3} /></span>
                {t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-5 relative">
        <ClipImage src="/img/chisiamo.jpg" alt="Zona pranzo di un appartamento ristrutturato" testid="about-image"
          className="aspect-[4/5] w-full lg:mt-24" />
        <Reveal delay={0.3} className="absolute -bottom-10 left-4 lg:left-8 bg-[#0d0d0e] text-[#f4f1ea] p-7 max-w-[280px] shadow-2xl">
          <p className="text-xs tracking-[0.25em] uppercase text-[#d4a73c]">Un solo numero da chiamare</p>
          <a href={SITE.phoneHref} data-testid="about-phone-badge" className="mt-3 block font-display text-3xl text-[#f4f1ea] hover:text-[#e8c063] transition-colors">{SITE.phone}</a>
          <p className="mt-3 text-sm text-[#d8d2c6] leading-snug">Dalla demolizione alle chiavi</p>
        </Reveal>
      </div>
    </div>
  </section>
);
